import { render, staticRenderFns } from "./VideoDialog.vue?vue&type=template&id=4e4ddf6a&scoped=true&"
import script from "./VideoDialog.vue?vue&type=script&lang=js&"
export * from "./VideoDialog.vue?vue&type=script&lang=js&"
import style0 from "./VideoDialog.vue?vue&type=style&index=0&id=4e4ddf6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4ddf6a",
  null
  
)

export default component.exports